module.exports = __webpack_public_path__ + "static/img/solutionPic4.476b24a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionPic4.png
// module id = ulNb
// module chunks = 1